export const ARTIFICIAL_PROGRESS_RATE = 0.001;
